module.exports = __webpack_public_path__ + "img/2.7969f4ac.jpg";